"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.negateSpace = void 0;
/** @jsx jsx */
var core_1 = require("@theme-ui/core");
var react_1 = require("react");
var resolveSpaceValue = function (value, spaces) {
    switch (typeof value) {
        case "number":
            return (spaces === null || spaces === void 0 ? void 0 : spaces[value]) || "0px";
        case "string":
            return value;
    }
    return undefined;
};
var negateSpace = function (space, spaces) {
    return Array.isArray(space)
        ? space.map(function (value) {
            var resolvedValue = resolveSpaceValue(value, spaces);
            return resolvedValue ? "calc(".concat(resolvedValue, " * -1)") : undefined;
        })
        : typeof space === "string" || typeof space === "number"
            ? "calc(".concat(resolveSpaceValue(space, spaces), " * -1)")
            : undefined;
};
exports.negateSpace = negateSpace;
/**
 * @description Renders a container with negative margins, allowing content
 * to "bleed" (see https://en.wikipedia.org/wiki/Bleed_(printing)) into the
 * surrounding layout. This is designed to make it easy to visually break
 * out of a parent container without having to refactor the entire component tree.
 */
var Bleed = function (_a) {
    var children = _a.children, top = _a.top, bottom = _a.bottom, left = _a.left, right = _a.right, horizontal = _a.horizontal, vertical = _a.vertical;
    var theme = (0, core_1.useThemeUI)().theme;
    return ((0, core_1.jsx)("div", { sx: theme.space
            ? {
                marginBottom: (0, exports.negateSpace)(bottom, theme.space),
                marginLeft: (0, exports.negateSpace)(left, theme.space),
                marginRight: (0, exports.negateSpace)(right, theme.space),
                marginTop: (0, exports.negateSpace)(top, theme.space),
                marginX: (0, exports.negateSpace)(horizontal, theme.space),
                marginY: (0, exports.negateSpace)(vertical, theme.space),
            }
            : undefined }, children));
};
exports.default = (0, react_1.memo)(Bleed);
